import util from './util';
import Slot from '../../domain/Slot';

export default (config: PrebidConfig, slot: Slot, slotBidderCfg: AnyObject) => {
	const {
			targetingFields = [],
			...params
		} = util.getParamsFromConfig(config, slotBidderCfg),
		targeting: Targeting = util.getTargeting(slot, targetingFields);

	params.keywords = targetingToKeywords(targeting);

	return {
		bidder: slotBidderCfg.bidder || 'msft',
		params
	};
};

function targetingToKeywords(targeting: Targeting): string {
	return Object.entries(targeting)
		.flatMap(([key, value]) =>
			Array.isArray(value)
				? value.map(v => ([key, v]))
				: [[key, value]])
		.map(([key, value]) => `${key}=${value}`)
		.join(',');
}
